import React from 'react';
import { Link } from 'react-router-dom';
import { Layout, Row, Col } from 'antd';

const { Footer } = Layout;


const Footer09 = ({extraCopyright}) => {
    return (
        <Footer className={'footer'}>
            <Row justify={'center'} algin={'middle'}>
                <Col>
                    <a className={'footer__logo-box'} href={"http://www.develop09.com"} target={'blank'}>
                        <div className={'footer__logo footer__logo--left'}/>
                        <div className={'footer__logo footer__logo--right'}/>
                    </a>
                    <a className={'footer__contact'} href="mailto: kjwonjg@gmail.com">
                        Contact
                    </a>
                    <Link className={'footer__pp'} to={'/privacy'}>
                        Privacy Policy
                    </Link>
                    <p className={'footer__copyright'}>©2020 Dev09</p>
                </Col>
            </Row>
        </Footer>
    );
}

export default Footer09;